import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuardService } from '@nx-ahs/shared/guards';
import { DynamicRouteGuardService } from './core/guards/dynamic-route-guard.service';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./core/components/menu/menu.module').then((m) => m.MenuPageModule),
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'admin',
		loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
		canActivate: [AuthenticationGuardService]
	},
	{
		path: 'home',
		loadChildren: () => import('./modules/my-members/my-members.module').then((m) => m.MyMembersModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'error',
		loadChildren: () => import('./modules/error-handling/error-handling.module').then((m) => m.ErrorHandlingModule),
		data: {
			ignoreMenu: true
		}
	},
	{
		path: 'settings',
		loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsPageModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'help',
		loadChildren: () => import('./modules/help/help.module').then((m) => m.HelpPageModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'secure-messaging',
		loadChildren: () =>
			import('./modules/secure messaging/secure-messaging.module').then((m) => m.SecureMessagingPageModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'document',
		loadChildren: () => import('./modules/document/document.module').then((m) => m.DocumentModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'history',
		loadChildren: () => import('./modules/history/history.module').then((m) => m.HistoryModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'payment',
		loadChildren: () => import('./modules/payment/payment.module').then((m) => m.PaymentModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'provider-search',
		loadChildren: () =>
			import('./modules/provider-search/provider-search.module').then((m) => m.ProviderSearchModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'file-a-complaint',
		loadChildren: () => import('./modules/complaint/complaint.module').then((m) => m.ComplaintModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'more',
		loadChildren: () => import('./modules/more/more.module').then((m) => m.MoreModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'application',
		loadChildren: () => import('./modules/application/application.module').then((m) => m.ApplicationModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'security/login',
		loadChildren: () => import('./modules/security/security.module').then((m) => m.SecurityModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/forgot-password',
		loadChildren: () =>
			import('./modules/security/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordPageModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/maintenance',
		loadChildren: () =>
			import('./modules/security/maintenance/maintenance.module').then((m) => m.MaintenancePageModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/confirm-account',
		loadChildren: () =>
			import('./modules/security/confirm-account/confirm-account.module').then((m) => m.ConfirmAccountPageModule),
		data: {
			ignoreMenu: true
			//ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/reset-password',
		loadChildren: () =>
			import('./modules/security/reset-password/reset-password.module').then((m) => m.ResetPasswordPageModule),
		data: {
			ignoreMenu: true
			//ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/forget-password-reset',
		loadChildren: () =>
			import('./modules/security/forgot-password-reset/foget-password-reset.module').then(
				(m) => m.ForgetPasswordResetPageModule
			),
		data: {
			ignoreMenu: true
			//ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/forget-username',
		loadChildren: () =>
			import('./modules/security/retrieve-username/retrieve-username.module').then(
				(m) => m.RetrieveUsernameModule
			),
		data: {
			ignoreMenu: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'security/external-link-confirmation',
		loadChildren: () =>
			import('./modules/security/external-link-confirmation/external-link-confirmation.module').then(
				(m) => m.ExternalLinkConfirmationModule
			),
		canActivate: [DynamicRouteGuardService]
	},
	//{
	//    path: 'security/two-factor-auth',
	//    loadChildren: () => import('./modules/security/two-factor-auth/two-factor-auth.module').then(m => m.TwoFactorAuthPageModule),
	//    data: {
	//        ignoreMenu: true
	//    }
	//},
	{
		path: 'security/register',
		loadChildren: () => import('./modules/security/register/register.module').then((m) => m.RegisterPageModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'view-pdf',
		loadChildren: () => import('./modules/view-pdf/view-pdf.module').then((m) => m.ViewPdfModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'tripetto',
		loadChildren: () => import('@nx-ahs/script-collector').then((m) => m.CollectorModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'tripetto',
		loadChildren: () => import('@nx-ahs/script-collector').then((m) => m.CollectorModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'pcp-update',
		loadChildren: () => import('./modules/pcp-update/pcp-update.module').then((m) => m.PcpUpdateModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'script-action',
		loadChildren: () =>
			import('./modules/script-actions/script-actions.module').then((m) => m.ScriptActionsModalModule),
		canActivate: [DynamicRouteGuardService, AuthenticationGuardService]
	},
	{
		path: 'landing',
		loadChildren: () => import('./modules/landing/landing.module').then((m) => m.LandingModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'updateEmailConsent',
		loadChildren: () =>
			import('./modules/email-confirmation/email-confirmation.module').then((m) => m.EmailConfirmationModule),
		data: {
			ignoreMenu: true,
			ignoreSplash: true
		},
		canActivate: [DynamicRouteGuardService]
	},
	{
		path: 'formly',
		loadChildren: () =>
			import('./modules/formly-custom-components/formly-lazy-wrapper.module').then(
				(m) => m.FormlyLazyWrapperModule
			),
		canActivate: [AuthenticationGuardService],
		data: { isAHSOnly: true, isDevOnly: true }
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
